// Shared SortableJS options for the seating chart.
//
// With native HTML5 drag-and-drop the browser draws its own faded snapshot of
// the item, which can't be styled. Fallback mode makes Sortable render a clone
// that follows the cursor instead; `.drag-lift` (stylesheets/application.css)
// turns that clone into a lifted card so it's obvious what is being dragged.
export const dragLiftOptions = {
  forceFallback: true,
  fallbackOnBody: true,       // append the clone to <body> so no ancestor clips it
  fallbackTolerance: 3,       // px of movement before a drag starts, so clicks stay clicks
  fallbackClass: 'drag-lift',
  ghostClass: 'drag-placeholder', // the original item left behind while dragging
  animation: 150,
  delay: 150,
  delayOnTouchOnly: true      // let touch users scroll past cards without starting a drag
}
